import { Grid, Typography } from '@mui/material';
import usePlanStore from 'store/planStore';

type Props = {
  countryName: string;
  baseBudget: number;
  currency: string;
  format: (v: string | number) => string;
};

export default function DDXSummary({
  countryName,
  baseBudget,
  currency,
  format,
}: Props) {
  const ddx = usePlanStore((s) => s.storedCountryForms?.[countryName]?.ddx);

  let value = 0;

  if (ddx?.type === 'percentage' && ddx.value != null) {
    value = baseBudget * ddx.value;
  } else if (ddx?.type === 'fixed' && ddx.value != null) {
    value = ddx.value;
  }

  return (
    <Grid
      container
      sx={{
        p: '24px 46px 24px 15px',
        backgroundColor: ddx ? 'tableBackground.main' : '#F00F00',
      }}
    >
      <Grid
        item
        xs={12}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Typography fontWeight={700} color={ddx ? '#525F81' : '#FFFFFF'}>
          TOTAL DDX
        </Typography>
        <Typography fontWeight={700} color={ddx ? '#525F81' : '#FFFFFF'}>
          {value ? `${format(value?.toFixed(0))} ${currency}` : 'N/A'}
        </Typography>
      </Grid>
    </Grid>
  );
}
